import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectStreet, selectCity, selectPostalCode, selectInvoiceStreet, selectInvoiceCity, selectInvoicePostalCode, selectShowInvalids, selectCountry } from '@store/order/selectors';
import { setStreet, setCity, setPostalCode, setInvoiceStreet, setInvoiceCity, setInvoicePostalCode, setCountry } from '@store/order/slice';
import AddressForm from '@components/address-form/AddressForm';
import Checkbox from '@components/checkbox/Checkbox';
import Select from '@components/select/Select';
import SelectItem from '@components/select/SelectItem';
import { AppLanguageCode, isAppLanguageCode } from '@project-types/AppLanguageCodes';
import { FORM_SELECT_LANGUAGES } from '@@/languageConfig';



const CustomerAddress = () => {
	const { t } = useTranslation('forms');

	const invoiceStreet = useSelector(selectInvoiceStreet);
	const invoiceCity = useSelector(selectInvoiceCity);
	const invoicePostalCode = useSelector(selectInvoicePostalCode);

	const street = useSelector(selectStreet);
	const city = useSelector(selectCity);
	const postalCode = useSelector(selectPostalCode);

	const showInvalids = useSelector(selectShowInvalids);
	const country = useSelector(selectCountry);

	const dispatch = useDispatch();
	const updateInvoiceStreet = (value: string | null) => dispatch(setInvoiceStreet(value));
	const updateInvoiceCity = (value: string | null) => dispatch(setInvoiceCity(value));
	const updateInvoicePostalCode = (value: string | null) => dispatch(setInvoicePostalCode(value));

	const updateStreet = (value: string | null) => dispatch(setStreet(value));
	const updateCity = (value: string | null) => dispatch(setCity(value));
	const updatePostalCode = (value: string | null) => dispatch(setPostalCode(value));

	const updateCountry = (value: AppLanguageCode) => dispatch(setCountry(value));

	const [ selected, setSelection ] = useState(false);

	return (
		<div className='customer-address-section'>

			<div className='customer-text'>
				<h2>{selected ? t('customerAddress.invoiceAddress') : t('customerAddress.address')}</h2>
			</div>

			<AddressForm
				streetValue={invoiceStreet}
				cityValue={invoiceCity}
				postalCodeValue={invoicePostalCode}
				onChangeStreet={updateInvoiceStreet}
				onChangeCity={updateInvoiceCity}
				onChangePostalCode={updateInvoicePostalCode}
				required={true}
				showInvalids={showInvalids} />


			<Checkbox isSelected={selected} onChange={setSelection}>
				{t('customerAddress.checkboxLabel')}
			</Checkbox>

			{selected &&
				<div className='delivery-adress'>
					
					<h3>{t('customerAddress.deliveryAddress')}</h3>
					
					<AddressForm
						streetValue={street}
						cityValue={city}
						postalCodeValue={postalCode}
						onChangeStreet={updateStreet}
						onChangeCity={updateCity}
						onChangePostalCode={updatePostalCode}
						showInvalids={showInvalids && (street || city || postalCode) ? true : false} />

				</div>}

			{FORM_SELECT_LANGUAGES && FORM_SELECT_LANGUAGES.length > 0 &&
				<Select
					label={t('inputLabels.countries')}
					selectedKey={country}
					placeholder={t('shared.selectPlaceholder')}
					onSelectionChange={(key) => {
						if (isAppLanguageCode(key)) {
							updateCountry(key);
						}
					}}
				>
					{FORM_SELECT_LANGUAGES.map(x =>
						<SelectItem id={x} key={x}>{t(`shared.countries.${x}`)}</SelectItem>
					)}
				</Select>
			}
		</div>
	);
};

export default CustomerAddress;